import { lazyWithRetry } from "../../utils/lazyWithRetry";

const PagesRoutes = [
  // PAGES
  {
    path: "/conversations",
    component: lazyWithRetry(() => import("../../view/pages/conversations")),
    layout: "VerticalLayout",
  },
  {
    path: "/notifications",
    component: lazyWithRetry(() => import("../../view/pages/notifications")),
    layout: "VerticalLayout",
  },
  {
    path: "/conversation/:id",
    component: lazyWithRetry(() => import("../../view/pages/conversations")),
    layout: "VerticalLayout",
  },
  {
    path: "/contacts",
    component: lazyWithRetry(() => import("../../view/pages/contacts")),
    layout: "VerticalLayout",
  },
  {
    path: "/contacts-details/:id",
    component: lazyWithRetry(() => import("../../view/pages/contacts-details")),
    layout: "VerticalLayout",
  },
  {
    path: "/profile/*",
    component: lazyWithRetry(() => import("../../view/pages/profile")),
    layout: "VerticalLayout",
  }
];

export default PagesRoutes;
